// index.js
// Loads advocacy issue configurations and exposes helpers for routing and navigation.

function toSlug(value) {
  if (!value) {
    return '';
  }

  return String(value)
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/\s+/g, '-')
    .replace(/_/g, '-')
    .toLowerCase();
}

const issueModules = import.meta.glob('./**/*.js', { eager: true });

export const ISSUES = Object.entries(issueModules)
  .map(([modulePath, moduleExports]) => {
    const [stateFolder, issueFile] = modulePath.replace('./', '').replace('.js', '').split('/');
    const stateSlug = toSlug(stateFolder);
    const issueSlug = toSlug(issueFile);
    const metadata = moduleExports.ISSUE_METADATA ?? {};

    return {
      id: `${stateSlug}-${issueSlug}`,
      stateCode: stateFolder,
      issueKey: issueFile,
      stateSlug,
      issueSlug,
      title: metadata.title ?? issueFile,
      summary: metadata.summary ?? '',
      bills: moduleExports.BILLS ?? [],
      groups: moduleExports.GROUPS ?? [],
      barrierStories: moduleExports.BARRIER_STORY_CONTENT ?? [],
      storyScroll: moduleExports.STORY_SCROLL_CONTENT ?? {},
    };
  })
  .sort((left, right) => {
    if (left.stateSlug === right.stateSlug) {
      return left.issueSlug.localeCompare(right.issueSlug);
    }

    return left.stateSlug.localeCompare(right.stateSlug);
  });

export function findIssueBySlug(stateSlug, issueSlug) {
  return ISSUES.find(
    (issue) => issue.stateSlug === toSlug(stateSlug) && issue.issueSlug === toSlug(issueSlug),
  );
}
